import { render, staticRenderFns } from "./BookingRequests.vue?vue&type=template&id=a107214c"
import script from "./BookingRequests.vue?vue&type=script&lang=js"
export * from "./BookingRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports